<template>
<div id="apptable" v-cloak>

    <b-card :header="'Partecipanti ' + getDescTipo(this.tipo).toLowerCase() + ' #' + id" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">

            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>                
                <div class="col-md-4">
                    <b-button style="margin:1px 0px 1px 2px;" v-if="tipoevento == 'R'" variant="warning" v-on:click="annullasorteggio()">
                        Annulla sorteggio
                    </b-button>               
                    <b-button style="margin:1px 0px 1px 2px;" v-if="tipoevento == 'R'" variant="primary" v-on:click="eseguisorteggio()">
                        Esegui sorteggio
                    </b-button>
                </div>
                <div class="col-md-5 text-right">
                    <b-button style="margin:1px 0px 1px 2px;" size="md" variant="outline-secondary" @click.stop="exportCSV()">
                        Esporta CSV
                    </b-button>
                    <b-button style="margin:1px 0px 1px 2px;" size="md" variant="outline-primary" @click.stop="insert()">
                        Inserisci
                    </b-button>
                </div>                             
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="id" scope="row">{{row.value}}</template>
                        <template slot="id" scope="row">{{row.value}}</template>
                        <template slot="cognomesocio" scope="row">{{row.value}}</template>
                        <template slot="nomesocio" scope="row">{{row.value}}</template>
                        <template slot="accountsocio" scope="row">{{row.value}}</template>
                        <template slot="numposti" scope="row">{{row.value}}</template>
                        <template slot="datains" scope="row">{{row.value | formatDateTime}}</template>
                        <template slot="stato" scope="row">{{row.value}}</template>
                        <template slot="posizionesorteggio" scope="row"><b :style="getPosizioneSorteggio(row.item)">{{row.value}}</b></template>
                        <template slot="vincitoreVis" scope="row"><b :style="getPosizioneSorteggio(row.item)">{{row.value}}</b></template>

                        <template slot="totacconto" scope="row">
                            <div :style="getImportoStyle(row.value)">
                                {{row.value}}
                            </div>
                        </template>
                        <template slot="totsaldo" scope="row">
                            <div :style="getImportoStyle(row.value)">
                                {{row.value}}
                            </div>
                        </template>

                        <template slot="modifica" scope="row">
                            <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                            <b-btn style="margin:0px 0px 1px 2px;" variant="warning" size="sm" @click.stop="del(row.item,row.index,$event.target)">Elimina</b-btn>
                            <!-- <b-btn style="margin:0px 0px 1px 2px;" v-if="tipoevento == 'D'" size="sm" @click.stop="details(row.item,row.index,$event.target)">Modifica</b-btn>   -->
                            <b-btn style="margin:0px 0px 1px 2px;" size="sm" @click.stop="details(row.item,row.index,$event.target)">Modifica</b-btn>                         
                        </template>

            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>

    <!-- Modal Component -->
    <b-modal v-model="deleteModal.show" title="Elimina">
        <p class="my-2">Confermi l'eliminazione della partecipazione #{{deleteModal.id}}?</p>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="delItem()" style="margin: 2px;">
                Conferma
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="deleteModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>
    
</div>
</template>

<script>
import moment from 'moment'

import {
    NAMESPACE
} from '../config.js'

import {
    Partecipa,
    Categoria,
    Socio
} from '../classes.js'

import {
    ctrlVismenu
} from '../util.js'

export default {
    name: 'apptable',
    data: function () {
        return {      
            id: this.$route.params.id,
            tipo: this.$route.params.tipo,
            tipoevento: this.$route.params.tipoevento,      
            items: [],
            namespace: NAMESPACE,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                cognomesocio: {
                    label: 'Cognome socio',
                    sortable: true
                },
                nomesocio: {
                    label: 'Nome socio',
                    sortable: true
                },
                accountsocio: {
                    label: 'Email socio',
                    sortable: true
                },
                numposti: {
                    label: 'Numero posti',
                    sortable: true
                },
                datains: {
                    label: 'Data inserimento',
                    sortable: true
                },
                stato: {
                    label: 'Stato',
                    sortable: true
                },
                posizionesorteggio: {
                    label: 'Posizione sorteggio',
                    sortable: true
                },
                vincitoreVis: {
                    label: 'Vincitore',
                    sortable: true
                },
                totacconto: {
                    label: 'Acconto riscosso/totale €',
                    sortable: true
                },
                totsaldo: {
                    label: 'Saldo riscosso/totale €',
                    sortable: true
                },
                modifica: {
                    label: ' ',
                    'class': 'text-right'
                }
            },
            deleteModal: {
                id: null,
                show: false
            },
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 10,
                value: 10
            }, {
                text: 25,
                value: 25
            }, {
                text: 50,
                value: 50
            }],
            sortBy: null,
            sortDesc: false,
            filter: null,
            totalRowsFilter: null,
            modalDetails: {
                index: '',
                data: ''
            },
            error: '',
            showerror: false,
            showtable: false
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        }
    },
    methods: {
        exportCSV() {

            if (this.items.length > 0) {
                var str = "TITOLO" + ";" + this.items[0].titoloscheda + "\r\n";
                str += "NOTE" + ";" + this.items[0].notescheda + "\r\n" + "\r\n";
                str += '"#";"Cognome socio";"Nome socio";"Email socio";"Numero posti";"Data inserimento";"Stato";"Note";"Note socio";'
                if(this.tipoevento == 'R'){
                    str += '"Posizione sorteggio";"Vincitore";';
                }
                str += '"Acconto riscosso/totale €";"Saldo riscosso/totale €"\r\n';
                for (var i = 0; i < this.items.length; i++) {
                    str += '"' + this.items[i].id + '"' + ";";
                    str += '"' + this.items[i].cognomesocio.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].nomesocio.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].accountsocio.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].numposti + '"' + ";";
                    str += '"' + this.items[i].datains + '"' + ";";
                    str += '"' + this.items[i].stato.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].note.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].noteutente.replace(/\"/g, "\"\"") + '"' + ";";

                    if(this.tipoevento == 'R'){
                        str += '"' + this.items[i].posizionesorteggio.replace(/\"/g, "\"\"") + '"' + ";";
                        str += '"' + this.items[i].vincitoreVis.replace(/\"/g, "\"\"") + '"' + ";";
                    }

                    str += '"' + this.items[i].totacconto + '"' + ";";
                    str += '"' + this.items[i].totsaldo + '"' + "\r\n";
                }

                var a = document.createElement('a');
                var blob = new Blob([str], {
                    'type': 'application\/octet-stream'
                });

                a.href = window.URL.createObjectURL(blob);
                a.download = 'partecipanti_' + this.id + '_' + moment(String(new Date())).format('YYYYMMDD_HHmmss') + '.csv';
                document.body.appendChild(a);
                a.click();
                setTimeout(function() {
                    document.body.removeChild(a);
                }, 100);


            }

        },
        insert() {
            this.$router.push('/app/dettagliopartecipa/id_scheda/' + this.id + '/tipo/' + this.tipo + '/tipoevento/' + this.tipoevento);
        },
        details(item, index, button) {

            this.$router.push('/app/dettagliopartecipa/id/' + item.id + '/id_scheda/' + this.id + '/tipo/' + this.tipo + '/tipoevento/' + this.tipoevento);

        },
        del(item, index, button) {
            this.deleteModal.id = item.id;
            this.deleteModal.show = true;
        },
        annullasorteggio() {

            let res = confirm("Confermi di voler annullare il sorteggio per l'evento #" + this.id + "?");
            if(res){

                var token = localStorage.getItem('token');
                this.axios.delete(NAMESPACE + 'rest/partecipasorteggio/id_scheda/' + this.id + '/tipo/' + this.tipo, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                //refresh data
                                this.loadData();

                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {

                            this.showerror = true;
                            this.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {

                        this.showerror = true;
                        this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });
            }

        },
        eseguisorteggio() {
            
            let res = confirm("Confermi di voler eseguire il sorteggio per l'evento #" + this.id + "?");
            if(res){

                var token = localStorage.getItem('token');
                this.axios.get(NAMESPACE + 'rest/partecipasorteggio/id_scheda/' + this.id + '/tipo/' + this.tipo, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                //refresh data
                                this.loadData();

                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {

                            this.showerror = true;
                            this.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {

                        this.showerror = true;
                        this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });
            }

        },
        delItem() {

            var token = localStorage.getItem('token');
            this.axios.delete(NAMESPACE + 'rest/partecipa/' + this.deleteModal.id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            //forse può essere fatta diversamente e meglio
                            for (var i = 0; i < this.items.length; i++) {
                                if (this.items[i].id == this.deleteModal.id) {
                                    this.items.splice(i, 1); //delete
                                    break;
                                }
                            }
                            this.deleteModal.show = false;


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {

                        this.deleteModal.show = false;
                        this.showerror = true;
                        this.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {

                    this.deleteModal.show = false;
                    this.showerror = true;
                    this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        getDescTipo(tipo) {
            var cat = new Categoria();
            return cat.getTipoByFlag(tipo);
        },
        getPosizioneSorteggio(item){
            if(item.flagvincitore == 'S'){
                return 'color: green;';
            }
            return '';
        },
        getImportoStyle(importo){
            if(typeof importo != 'undefined' && importo.indexOf("/") >= 0){
                var parz = Number.parseFloat(importo.split('/')[0]);
                var tot = Number.parseFloat(importo.split('/')[1]);
                if(parz == tot){
                    return "font-weight:bold;color:green;";
                }
                if(parz < tot){
                    return "font-weight:bold;color:red;";
                }
                else{
                    return "font-weight:bold;color:blue;";
                }
            }
            return "";
        },
        loadData(){

             var token = localStorage.getItem('token');
            this.axios.get(NAMESPACE + 'rest/partecipa/id_scheda/' + this.id + '/tipo/' + this.tipo, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        this.items = response.data.message;
                        let apptable = this;

                        var partecipa = new Partecipa();
                        apptable.items.forEach(function(element, index) {
                            element.stato = partecipa.getStatoByFlag(element.flagsta);
                            element.datainizio = apptable.$options.filters.formatDate(element.datainizio);
                            element.datafine = apptable.$options.filters.formatDate(element.datafine);                            
                            element.datains_ric = apptable.$options.filters.formatDateTime(element.datains);
                            element.votoNessuno = (element.voto == 0 ? 'Nessuno' : ''); //per far funzionare la ricerca

                            //alert("Totale acconto: " + element.totaleacconto);
                            //alert("Totale pagato: " + element.totalepagato);
                            
                            element.totacconto = Number.parseFloat((element.totalesaldo == 0 ? element.totalepagato : Math.min(element.totaleacconto, element.totalepagato))).toFixed(2) + "/" + Number.parseFloat(element.totaleacconto).toFixed(2);
                            element.totacconto = (element.totacconto == '0.00/0.00' ? '' : element.totacconto);

                            var auxdiff = element.totalepagato - (element.totalesaldo == 0 ? element.totalepagato : Math.min(element.totaleacconto, element.totalepagato));
                            auxdiff = (auxdiff < 0 ? 0 : auxdiff);
                            element.totsaldo = Number.parseFloat(auxdiff).toFixed(2) + "/" + Number.parseFloat(element.totalesaldo).toFixed(2); 
                            element.totsaldo = (element.totsaldo == '0.00/0.00' ? '' : element.totsaldo);

                            element.vincitoreVis = (element.flagvincitore == 'S' ? 'Sì' : 'No');

                            delete element.uteins; //per motivi di ricerca

                            //element.ruoloVis = socio.getRuoloByFlag(element.flgruolo);
                        });

                        this.showtable = true;

                    } else {
                        throw new Error(response.data.message);
                    }

                } catch (e) {
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                this.showerror = true;
                this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });

        },
    },
    filters: {
        formatDate: function(value) {
            if (!value) return '';
            return moment(String(value)).format('DD/MM/YYYY');
        },
        formatDateTime: function (value) {
            if (!value) return '';
            return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
        },
        formatNote: function(value) {
            var numChar = 150;
            if (!value) return '';
            return value.substr(0, numChar) + (value.length <= numChar ? '' : ' ...');
        }
    },
    created: function () {

        
        if(!ctrlVismenu("E")){
            this.$router.replace('/accessdenied');
            return;
        }

        //diverso da sorteggio
        if(this.tipoevento != 'R'){
            delete this.fields.posizionesorteggio;
            delete this.fields.vincitoreVis;
        }

        this.loadData();

    }
}
</script>
